var Handlebars = require("handlebars/dist/handlebars.runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.pastDraws : depth0),{"name":"each","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "        <div class=\"panel panel-default "
    + alias2(alias1((depth0 != null ? depth0.DrawGameId : depth0), depth0))
    + "\">\r\n            <div class=\"panel-heading\" role=\"tab\" id=\"heading-pastNumber-"
    + alias2(alias1(((stack1 = (data && data.root)) && stack1.uniqueId), depth0))
    + "-"
    + alias2(alias1((data && data.index), depth0))
    + "\">\r\n                <div class=\"panel-title collapsed\" role=\"button\" data-toggle=\"collapse\" data-parent=\"#"
    + alias2(alias1(((stack1 = (data && data.root)) && stack1.accordionId), depth0))
    + "\" data-target=\"#pastNumber-"
    + alias2(alias1(((stack1 = (data && data.root)) && stack1.uniqueId), depth0))
    + "-"
    + alias2(alias1((data && data.index), depth0))
    + "\" aria-expanded=\"false\" aria-controls=\"pastNumber-"
    + alias2(alias1(((stack1 = (data && data.root)) && stack1.uniqueId), depth0))
    + "-"
    + alias2(alias1((data && data.index), depth0))
    + "\">\r\n"
    + ((stack1 = container.invokePartial(require("C:\\Work\\VALottery-Celerity\\Trunk\\VAL\\frontend\\src\\features\\draw-games\\past-numbers\\past-numbers-accordion-panel-title.handlebars"),depth0,{"name":"./past-numbers-accordion-panel-title","data":data,"indent":"                    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "                </div>\r\n            </div>\r\n            <div id=\"pastNumber-"
    + alias2(alias1(((stack1 = (data && data.root)) && stack1.uniqueId), depth0))
    + "-"
    + alias2(alias1((data && data.index), depth0))
    + "\" class=\"panel-collapse collapse\" role=\"tabpanel\" aria-labelledby=\"heading-pastNumber-"
    + alias2(alias1(((stack1 = (data && data.root)) && stack1.uniqueId), depth0))
    + "-"
    + alias2(alias1((data && data.index), depth0))
    + "\">\r\n                <div class=\"panel-body\">\r\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (data && data.root)) && stack1.isDayNightGame),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.program(5, data, 0),"data":data})) != null ? stack1 : "")
    + "                </div>\r\n            </div>\r\n        </div>\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(require("C:\\Work\\VALottery-Celerity\\Trunk\\VAL\\frontend\\src\\features\\draw-games\\past-numbers\\past-numbers-accordion-panel-body-daynightgame.handlebars"),depth0,{"name":"./past-numbers-accordion-panel-body-daynightgame","data":data,"indent":"                        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"5":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (data && data.root)) && stack1.isKenoGame),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.program(8, data, 0),"data":data})) != null ? stack1 : "");
},"6":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(require("C:\\Work\\VALottery-Celerity\\Trunk\\VAL\\frontend\\src\\features\\draw-games\\past-numbers\\past-numbers-accordion-panel-body-keno.handlebars"),depth0,{"name":"./past-numbers-accordion-panel-body-keno","data":data,"indent":"                        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"8":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(require("C:\\Work\\VALottery-Celerity\\Trunk\\VAL\\frontend\\src\\features\\draw-games\\past-numbers\\past-numbers-accordion-panel-body.handlebars"),depth0,{"name":"./past-numbers-accordion-panel-body","data":data,"indent":"                        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"10":function(container,depth0,helpers,partials,data) {
    return "    <p>\r\n        <i>Data is not available at this time.</i>\r\n    </p>\r\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.pastDraws : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(10, data, 0),"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true});


//////////////////
// WEBPACK FOOTER
// ./features/draw-games/past-numbers/past-numbers-accordion.handlebars
// module id = 56
// module chunks = 0